/* eslint-disable import/first */
import React from 'react';

export default function BackArrow(props) {
  const { fill = 'none', width = '30', height = '30' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5355 15.0002L19.723 21.1877L17.9555 22.9552L10.0005 15.0002L17.9555 7.04517L19.723 8.81267L13.5355 15.0002Z"
        fill="black"
      />
    </svg>
  );
}
